/**
 * Ce qui n'est pas terminé, et ce que ça fausse.
 *
 * Règle de la section : tant qu'un chantier n'est pas déclaré fini, tout
 * chiffre qui en dépend est marqué « en cours de développement ». Un écran qui
 * affiche un résultat calculé sur une donnée absente ment, même sans le
 * vouloir — c'est exactement le défaut qui a laissé sept APV sans réception
 * d'achat pendant quinze mois.
 *
 * Retirer une entrée d'ici suffit à rendre les chiffres correspondants
 * définitifs partout dans la section.
 */
export const DEV = {
  // sumal_apv est sorti d'ici le 2026-09-01 : SumalX2n reprend chaque nuit les trois
  // dates, le statut du dépôt et le stock déclaré, pour tous les APV. L'entrée a
  // donc été retirée, ce qui rend définitifs l'échéance et tout ce qui en dépend.
  // Le volume autorisé, lui, n'a jamais été dans SUMAL : il vient de la réception.
  aviz_status: {
    label: 'Contrôle du statut des avize (annulés, expirés)',
    state: 'en cours de développement',
    affects: 'tous les volumes sortis, qui incluent des avize peut-être annulés'
  },
  balance: {
    label: 'Pont-bascule',
    state: 'en maintenance',
    affects: 'pesées, densité, nombre de courses et donc coût de transport'
  }
}

export const DEV_LIST = Object.keys(DEV).map(k => ({ key: k, ...DEV[k] }))

/**
 * Le pont-bascule est-il en service ?
 *
 * Mesuré le 2026-09-01 sur 90 jours : 22 % des avize portent un tonnage, 19 %
 * une heure. Les colonnes Tonnes, Densité et Pesée sont donc vides quatre fois
 * sur cinq — et une colonne systématiquement vide est une bonne part de ce qui
 * fait « pas fini ». Tant que la bascule est arrêtée, on masque ce qu'elle
 * alimente au lieu d'afficher des tirets.
 *
 * Une ligne à repasser à `true` le jour où elle revient.
 *
 * CE QUE CE DRAPEAU NE MASQUE PLUS
 * Depuis le 2026-10-27 (demande de Chady : « la densité dans les tableaux
 * quand on l'a »), les colonnes Tonnes et Densité aviz par aviz de la fiche APV
 * et la densité de la liste des APV s'affichent toujours : l'auto-match relie
 * les pesées chaque heure depuis le 2026-09-24, et une densité ne s'écrit que
 * sur un aviz pesé, un tiret sinon. Ce drapeau ne garde plus que le contrôle
 * « Chaque aviz a sa pesée » de Qualité & synchro, qui lit 180 jours et
 * noierait les autres contrôles sous les avize d'avant la reprise de la bascule.
 */
export const WEIGHBRIDGE_LIVE = false

/** Vrai tant qu'au moins un des chantiers cités n'est pas terminé. */
export const isProvisional = (...keys) => keys.some(k => !!DEV[k])
